import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import Datetime from 'react-datetime';
import ErrorMessage from './ErrorMessage';

import "react-datetime/css/react-datetime.css";

const DataTimeInput = ({name, placeholder, utc=false, timeFormat=true}) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => {
        const inputProps = {
          id: field.name,
          autoComplete: "off",
        }

        if(!field.value){
          inputProps.value = ''
        }

        return (
          <div className="mb-3">
            <div className={`form-floating react-datetime-group ${inputProps.value !== '' ? 'has-value' : ''}`}>
              <Datetime
                {...field}
                utc={utc}
                timeFormat={timeFormat}
                className={ invalid ? "is-invalid" : ""}
                inputProps={inputProps}
                closeOnSelect={true}
              />
              <label htmlFor={field.name}>{placeholder}</label>
            </div>
            <ErrorMessage error={error}/>
          </div>
        )
      }}
    />
  )
}

DataTimeInput.defaultProps = {};

DataTimeInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default DataTimeInput;